import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withFormik } from 'formik'
import _ from 'lodash'

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import withPortalAutoRemoteSync from '../../../modules/common/withPortalAutoRemoteSync'
import CheckboxGroup from '../../views/widgets/CheckboxGroup'
import InputCheckbox from '../../views/widgets/InputCheckbox'
import InputTags from '../../views/widgets/InputTags'
import config from '../../../config'
import { isNotEmpty } from '../../../services/utils'
import ImageUpload from '../../../modules/image/ImageUpload'
import withValidateBeforeSync from '../../../modules/common/withValidateBeforeSync'
import InputTextarea from '../../views/widgets/InputTextarea'

// const ImageUploader = withImageListItem(ImageItem)

const GeneralInfoForm = ({
  language,
  values,
  touched,
  errors,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleBlur,
  handleAutoSyncOnBlur,
  updatePortalAtPath,
  handleSubmit,
  handleReset,
  dirty,
}) => (
  <div>
    <Field label="เปิดใช้ในภาษา">
      <CheckboxGroup
        name="availableLangs"
        values={values.availableLangs}
        onChange={values => updatePortalAtPath('availableLangs', values)}
      >
        <InputCheckbox id="th" value="th" name="ไทย" />
        <InputCheckbox id="en" value="en" name="English" />
        <InputCheckbox id="zh" value="zh" name="Chaina" />
      </CheckboxGroup>
    </Field>

    <Field label="รูป">
      <ImageUpload name="mainImageId" value={values.mainImageId} />
    </Field>

    <Field label="ชื่อ">
      <InputText
        name={`title.${language}`}
        placeholder="Enter your title"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.title[language]}
        error={errors.title && errors.title[language]}
      />
    </Field>
    <Field label="แท็ก">
      <InputTags
        name={`tags`}
        placeholder="Enter your tags"
        onChange={value => {
          setFieldValue('tags', value)
          updatePortalAtPath('tags', value)
        }}
        values={values.tags}
        error={errors.tags && errors.tags[language]}
      />
    </Field>
    <Field label="รายละเอียดสั้น">
      <InputText
        name={`shortDescription.${language}`}
        placeholder="Enter your Short Description"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.shortDescription[language]}
      />
    </Field>
    <Field label="รายละเอียด">
      <InputTextarea
        name={`description.${language}`}
        placeholder="Enter your description"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.description[language]}
      />
    </Field>
    <Field label="ไฮไลท์">
      <InputText
        name={`highlightSentence.${language}`}
        placeholder="Ex. Restaurant, Wine, Beer"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.highlightSentence[language]}
      />
    </Field>

    {
      //   <Field label="ผู้เขียน">
      //   <InputText
      //     name={`editorNotes.${language}`}
      //     placeholder="Enter your editor Notes"
      //     onChange={handleChange}
      //     onBlur={handleAutoSyncOnBlur}
      //     value={values.editorNotes[language]}
      //   />
      // </Field>
    }

    <Field label="เวลาทำการ">
      <InputText
        name={`openingHours.${language}`}
        placeholder="Ex. เปิดบริการทุกวัน 17:00 - 01:00 น."
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.openingHours[language]}
      />
    </Field>
  </div>
)

const initialInformation = ({ tags, availableLangs, ...portal }) => ({
  title: config.getLangText(),
  shortDescription: config.getLangText(),
  description: config.getLangText(),
  highlightSentence: config.getLangText(),
  openingHours: config.getLangText(),
  editorNotes: config.getLangText(),
  ...portal,
  tags: isNotEmpty(tags) ? tags : [],
  availableLangs: isNotEmpty(availableLangs) ? availableLangs : ['th'],
})

const validateInformation = (values, { language }) => {
  // console.log("this.props.values", values.tags)
  let errors = {}

  if (!values.title || _.size(values.title[language]) <= 5) {
    errors.title = { th: 'ชื่อ ต้องมีความยาวอย่างน้อย 5 ตัวอักษร' }
  }

  if (_.isEmpty(values.tags)) {
    errors.tags = { th: 'แท็ก ต้องมีอย่างน้อย 1 แท็ก' }
  }

  // console.log(errors.tags, values.tags, _.size(values.tags))
  return errors
}

export default compose(
  connect(({ portal, info: { language } }) => ({ portal, language })),
  withFormik({
    mapPropsToValues: ({ portal }) => {
      return initialInformation(portal)
    },
    validate: validateInformation, // valilated ui
    enableReinitialize: true,
    isInitialValid: false,
    displayName: 'Information', // helps with React DevTools
  }),
  withPortalAutoRemoteSync(),
  withValidateBeforeSync({
    validate: validateInformation, // validate for sync
  }), // valilated ui
)(GeneralInfoForm)



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoForm.js